<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> Template
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Sign Request Templates</h2>

      <c-data-list :items="templates">
        <template v-slot:columns>
          <div class="col-12 col-lg-8">
            <p>Title</p>
          </div>
          <div class="col-12 col-lg-4 text-lg-end">
            <p>Type</p>
          </div>
        </template>
        <template v-slot:default="{ item }">
          <router-link :to="{ name: 'settings.sign-request-templates.show', params: { template_id: item.id } }">
            <div class="row">
              <div class="col-12 col-lg-8">
                <p class="text-truncate">
                  <span class="strong">{{ item.title }}</span>
                </p>
              </div>
              <div class="col-12 col-lg-4 justify-content-lg-end">
                <span class="badge rounded-pill bg-info">{{ item.type }}</span>
              </div>
            </div>
          </router-link>
        </template>
        <template v-slot:empty>
          <li class="py-4">
            <p class="text-center">No sign request templates yet.</p>
          </li>
        </template>
      </c-data-list>
    </div>

    <sign-request-template-modal
      ref="modal"
      title="Create Template"
      :template="newTemplate"
      @created="templateCreated"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SignRequestTemplateModal from './sign-request-templates/SignRequestTemplateModal'

export default {
  components: {
    SignRequestTemplateModal
  },

  data () {
    return {
      newTemplate: {
        title: '',
        type: ''
      }
    }
  },

  computed: {
    ...mapState('signRequestTemplate', { templates: 'list' })
  },

  created () {
    this.getTemplates()
  },

  methods: {
    ...mapActions('signRequestTemplate', { getTemplates: 'getList' }),

    templateCreated (template) {
      this.$router.push({ name: 'settings.sign-request-templates.show', params: { template_id: template.id } })
    }
  }
}
</script>
